import { styled } from "@mui/material";

export const SanitizedStyledWrapper = styled('div')({
    '& .page-content': {
      '& ul': {
        listStyleType: 'disc',
      },
    }
});

